let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dhpyr")).then(() => parcelRequire('9LBJH'));